import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    width: '100%',
    padding: spacing(0, 3, 3)
  },
  formControl: {
    margin: spacing(2, 0)
  },

  title: {
    color: '#000000',
    fontSize: '24px'
  },

  domains: {
    margin: '4px',
    fontSize: '14px'
  },

  subtitle: {
    color: '#9E9E9E'
  },
  btnSection: {
    display: 'flex',
    margin: spacing(2, 0),
    justifyContent: 'space-between'
  },
  switchContainer: {
    padding: '0px 10px',
    borderLeft: '1px solid #000',
    margin: '0px 10px'
  },

  divider: {
    margin: spacing(2, 0)
  },

  description: {
    marginBottom: spacing(2),
    letterSpacing: '0.25px'
  },

  clearBtn: {
    color: '#9E9E9E'
  },

  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [breakpoints.down('md')]: {
      width: '90%'
    },
    [breakpoints.up('md')]: {
      width: 625
    },
    borderRadius: '4px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    backgroundColor: '#fff',
    padding: spacing(3)
  },

  modalFooterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap'
  },

  modalFooterBtn: {
    margin: spacing(0, 1)
  }
}))
